/* =====================================================================
   Dropdowns — Manejo de apertura y cierre de dropdowns
   ===================================================================== */
    const initDropdowns = (parent = "") => {
        const container = parent ? parent + " [data-dropdown-toggle]" : "[data-dropdown-toggle]";

        document.querySelectorAll(container).forEach(function (details) {
            details.addEventListener('click', function () {
                details.parentNode.classList.toggle('open');
                if(details.closest('[data-dropdown-group]')) {
                    const group = details.closest('[data-dropdown-group]');
                    group.querySelectorAll(container).forEach(function (d) {
                    if (d !== details) {
                        d.parentNode.classList.remove('open');
                    }
                    });
                }
            });
        });
    }

    (function () {
        initDropdowns();
    })();

    
/* =====================================================================
   EmCart — Gestión del carrito con AJAX
   ===================================================================== */
(function () {
  'use strict';

  function onReady(fn) {
    if (document.readyState !== 'loading') { fn(); }
    else { document.addEventListener('DOMContentLoaded', fn); }
  }

  var EmCart = {

    /* Recarga el contenido del drawer y el badge haciendo fetch a la sección */
    refreshDrawer: function (itemElement = null) {
      fetch(window.location.href)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          if (!html) return;
          var doc = new DOMParser().parseFromString(html, 'text/html');

          var newBody    = doc.getElementById('cart-drawer-body');
          var currentBody = document.getElementById('cart-drawer-body');
          
          if (newBody && currentBody) {
            const itemCount = parseInt(doc.getElementById('cart-count').textContent, 10);
            if (itemElement && itemCount > 0) {
              var newItem = newBody.querySelector(`[data-cart-key="${itemElement.dataset.cartKey}"]`);
              if (newItem) {
                itemElement.replaceWith(newItem);
                initDropdowns(`[data-cart-key="${itemElement.dataset.cartKey}"]`);
              } else {
                itemElement.remove();
              }
              var newTotal = doc.getElementById('cart-total-price');
              var currentTotal = document.getElementById('cart-total-price');
              if (newTotal && currentTotal) {
                  currentTotal.innerHTML = newTotal.innerHTML;
                  currentTotal.classList.remove('loading');
              }
            } else {
                currentBody.innerHTML = newBody.innerHTML;
                initDropdowns('#cart-drawer-body');
            }
            
          }

          var newBadge     = doc.getElementById('cart-count');
          var currentBadge = document.getElementById('cart-count');
          if (newBadge && currentBadge) {
            currentBadge.textContent    = newBadge.textContent;
            currentBadge.style.display  = newBadge.style.display;
          }
        })
        .catch(function (err) { console.warn('[EmCart.refreshDrawer]', err); });
    },

    add: function (variantId, quantity, goToCheckout = false) {
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: quantity || 1 })
      })
        .then(function (r) {
          if (!r.ok) return r.json().then(function (e) { throw new Error(e.description || 'Error'); });
          return r.json();
        })
        .then(function () {
          EmCart.refreshDrawer();
          if (goToCheckout) {
            window.location.href = '/checkout';
          } else {
            EmCart.openDrawer();
          }
        })
        .catch(function (err) { console.warn('[EmCart.add]', err); });
    },

    change: function (key, quantity, itemElement = null) {
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: quantity })
      })
        .then(function (r) { return r.json(); })
        .then(function () {
            EmCart.refreshDrawer(itemElement);
        })
        .catch(function (err) { console.warn('[EmCart.change]', err); });
    },

    openDrawer: function () {
      var drawer  = document.getElementById('cart-drawer');
      var overlay = document.getElementById('cart-drawer-overlay');
      if (drawer)  { drawer.classList.add('open');  drawer.setAttribute('aria-hidden', 'false'); }
      if (overlay) overlay.classList.add('open');
      document.body.style.overflow = 'hidden';
    },

    closeDrawer: function () {
      var drawer  = document.getElementById('cart-drawer');
      var overlay = document.getElementById('cart-drawer-overlay');
      if (drawer)  { drawer.classList.remove('open'); drawer.setAttribute('aria-hidden', 'true'); }
      if (overlay) overlay.classList.remove('open');
      document.body.style.overflow = '';
    },

    /* Re-enlaza eventos del drawer tras refrescar su contenido */
    bindDrawerEvents: function (init = false, parent = "") {
      var body = document.getElementById('cart-drawer-body');
      if (!body) return;
 
      if (!init)
        initDropdowns(parent);

        // Un solo listener, no se duplica
        body.addEventListener('click', function (e) {
            var btn = e.target.closest('[data-cart-qty]');
            if (!btn) return;

            EmCart.change(btn.dataset.cartKey, parseInt(btn.dataset.cartQty, 10), btn.closest('.carro_wrap_item'));
            btn.closest('[data-dropdown]').classList.remove('open');
            btn.closest('[data-dropdown]').querySelector('.carro_text_dropdown-qtty').textContent = btn.dataset.cartQty;
            btn.closest('.carro_wrap_item').classList.add('loading');
            document.getElementById('cart-total-price').classList.add('loading');
            
        });
      

    },

    init: function () {
      /* Enlazar eventos del drawer inicial (ya renderizado por Liquid) */
      EmCart.bindDrawerEvents(true);

      var toggleBtn = document.getElementById('cart-drawer-toggle');
      if (toggleBtn) {
        toggleBtn.addEventListener('click', function (e) {
          e.preventDefault();
          EmCart.openDrawer();
        });
      }

      var closeBtn = document.getElementById('cart-drawer-close');
      if (closeBtn) closeBtn.addEventListener('click', EmCart.closeDrawer);

      var overlay = document.getElementById('cart-drawer-overlay');
      if (overlay) overlay.addEventListener('click', EmCart.closeDrawer);

      document.addEventListener('click', function (e) {
        if (!e.target.closest('[data-dropdown]')) {
          document.querySelectorAll('#cart-drawer-body [data-dropdown].open').forEach(function (d) { d.classList.remove('open'); });
          document.querySelectorAll('[data-dropdown-group="product-variants"] [data-dropdown].open').forEach(function (d) { d.classList.remove('open'); });
        }

        if (!e.target.closest('#cart-drawer')) {
          
        }
      });

      document.querySelectorAll('[name="add"]').forEach(function (btn) {
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          var form = btn.closest('form');
          if (!form) return;
          var variantId = (form.querySelector('[name="id"]') || {}).value;
          var qty = parseInt((form.querySelector('[name="quantity"]') || {}).value || 1, 10);
          const goToCheckout = btn.id.startsWith('buy-now');
          if (variantId) EmCart.add(variantId, qty, goToCheckout);
        });
      });
    }
  };

  window.EmCart = EmCart;
  onReady(EmCart.init.bind(EmCart));
})();

/* =====================================================================
   RelatedProducts — Carga dinámica de recomendaciones de productos relacionados
   ===================================================================== */
(function () {
    const relatedSections = document.querySelectorAll('product-recommendations');

    if (relatedSections.length === 0) return;

    relatedSections.forEach(function (section) {
      const data = section.dataset;
      var productId = data.productId;
      var url = data.url + '&section_id=' + data.sectionId + '&product_id=' + productId;

    fetch(url)
        .then(function (res) {
            if (!res.ok) throw new Error('HTTP ' + res.status);
            return res.text();
        })
        .then(function (html) {
            var parser = new DOMParser();
            var doc = parser.parseFromString(html, 'text/html');
            var newSection = doc.querySelector('product-recommendations');
            if (newSection) {
                section.innerHTML = newSection.innerHTML;
            }
        })
        .catch(function (err) {
            console.warn('[related-products] Error al cargar recomendaciones:', err);
        });
    });

})();

